<template>
  <b-row class="match-height">
    <b-col
      lg="10"
      offset="1"
    >
      <b-card title="Confirm Transfer By Warehouse Sender">
        <b-form @submit.prevent="submitConfirmTransfer">
          <b-row>
            <b-col
              cols="12"
              class="d-flex justify-content-between align-items-center mb-2"
            >
              <b-button
                type="button"
                variant="primary"
                @click="previous()"
              >
                <feather-icon
                  icon="ArrowLeftIcon"
                  size="16"
                  class="align-middle"
                />
                Back
              </b-button>

              <b-dropdown
                v-if="documents.length > 0"
                text="Download Documents"
                right
              >
                <b-dropdown-item
                  v-for="document in documents"
                  :key="document.document_transfer_id"
                  @click="downloadAttachment(document)"
                >
                  {{ document.document_file_name }}
                </b-dropdown-item>
              </b-dropdown>
            </b-col>
            <b-col cols="12">
              <hr>
            </b-col>
          </b-row>

          <b-row>
            <b-col cols="12">
              <b-form-group
                label="Transfer Number"
                label-cols-md="12"
              >
                <b-form-input
                  v-model="form.transferNumber"
                  readonly
                />
              </b-form-group>
              <b-form-group
                label="Transfer Sender *"
                label-cols-md="12"
              >
                <b-form-input
                  v-model="form.transferSender"
                  readonly
                />
              </b-form-group>
              <b-form-group
                label="Transfer Receiver *"
                label-cols-md="12"
              >
                <b-form-input
                  v-model="form.transferReceiver"
                  readonly
                />
              </b-form-group>
              <b-form-group
                label="Transfer Type *"
                label-cols-md="12"
              >
                <b-form-input
                  v-model="form.transferType"
                  readonly
                />
              </b-form-group>
              <b-form-group
                label="Transfer Notes *"
                label-cols-md="12"
              >
                <b-form-input
                  v-model="form.transferNotes"
                  readonly
                />
              </b-form-group>

              <b-form-group label="Status :">
                <vue-horizontal-timeline :items="statusItems" />
              </b-form-group>
            </b-col>
          </b-row>

          <b-form-group label="Items :">
            <div class="mt-2">
              <b-row class="mb-2">
                <b-col
                  :cols="isAssetTransfer ? 6 : 3"
                  class="text-center font-weight-bold"
                >
                  {{ isAssetTransfer ? 'Asset Name' : 'Item Name' }}
                </b-col>
                <b-col
                  cols="3"
                  class="text-center font-weight-bold"
                >
                  Requested QTY
                </b-col>
                <b-col
                  cols="3"
                  class="text-center font-weight-bold"
                >
                  Sent QTY
                </b-col>
                <b-col
                  v-if="!isAssetTransfer"
                  cols="3"
                  class="text-center font-weight-bold"
                >
                  Shelf
                </b-col>
              </b-row>

              <b-row
                v-for="item in items"
                :key="item.id"
                class="mb-2 align-items-center"
              >
                <b-col
                  :cols="isAssetTransfer ? 6 : 3"
                  class="text-center"
                >
                  <b-list-group>
                    <b-list-group-item>
                      <span v-if="isAssetTransfer && item.asset">
                        {{ item.asset.asset_number }} ({{ item.asset.item.item_code }})
                      </span>
                      <span v-else-if="item.item">
                        {{ item.item.item_name }} ({{ item.item.item_code }})
                      </span>
                    </b-list-group-item>
                  </b-list-group>
                </b-col>

                <b-col
                  cols="3"
                  class="text-center"
                >
                  <b-form-input
                    v-model="item.qty"
                    class="text-center"
                    readonly
                  />
                </b-col>

                <b-col
                  cols="3"
                  class="text-center"
                >
                  <b-form-input
                    v-model="item.accepted"
                    :max="item.qty"
                    type="number"
                    class="text-center"
                  />
                </b-col>

                <b-col
                  v-if="!isAssetTransfer"
                  cols="3"
                  class="text-center"
                >
                  <v-select-new
                    v-model="item.shelf"
                    :options="shelves"
                  />
                </b-col>

                <b-col cols="12">
                  <hr class="my-1">
                </b-col>
              </b-row>
            </div>
          </b-form-group>

          <b-col offset-md="12">
            <b-button
              type="submit"
              variant="primary"
              class="mr-1"
              :disabled="isSubmitDisabled"
            >
              {{ isSubmitDisabled ? 'Submitting...' : 'Submit' }}
            </b-button>
          </b-col>
        </b-form>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import {
  BRow, BCol, BFormGroup, BFormInput, BForm, BButton, BCard,
  BListGroup, BListGroupItem, BDropdown, BDropdownItem,
} from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import axios from 'axios'
import moment from 'moment-timezone'
import Ripple from 'vue-ripple-directive'
import { VueHorizontalTimeline } from 'vue-horizontal-timeline'
import vSelectNew from 'vue-select'
import apiEndpoints from '@/constants/apiEndpoints'

export default {
  components: {
    VueHorizontalTimeline,
    BCard,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BForm,
    BButton,
    BListGroup,
    BListGroupItem,
    BDropdown,
    BDropdownItem,
    vSelectNew,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      form: {
        transferNumber: '',
        transferSender: '',
        transferReceiver: '',
        transferType: '',
        transferNotes: '',
      },
      items: [],
      documents: [],
      statusItems: [],
      shelves: [],
      isSubmitDisabled: false,
      transferId: null,
    }
  },
  computed: {
    isAssetTransfer() {
      return this.form.transferType === 'Asset'
    },
    authHeaders() {
      return {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.$cookies.get('userToken')}`,
      }
    },
  },
  mounted() {
    this.initializeShelves()
    this.loadInitialData()
  },
  methods: {
    initializeShelves() {
      const shelfsVariables = (process.env.VUE_APP_SHELF_LIST || '').split(',')
      const shelfsRepeat = (process.env.VUE_APP_SHELF_REPEAT || '').split(',')
      this.shelves = []

      shelfsVariables.forEach(s => {
        shelfsRepeat.forEach(r => {
          // UBAH BAGIAN INI: Jadikan Object dengan label dan value
          this.shelves.push({
            label: `${s}${r}`,
            value: `${s}${r}`,
          })
        })
      })
    },

    async loadInitialData() {
      const item = JSON.parse(localStorage.getItem('TransferDetail'))
      if (!item) {
        this.showToast('Error', 'No transfer details found', 'danger')
        return
      }

      this.transferId = item.transfer_id
      this.populateHeaderForm(item)
      this.statusItems = this.buildTimelineStatus(item)

      await Promise.all([
        this.getDocuments(item.transfer_id),
        this.getTransferDetails(item.transfer_id),
      ])
    },

    populateHeaderForm(item) {
      this.form.transferNumber = item.transfer_number
      this.form.transferSender = `${item.sender.branch_name} (${item.sender.branch_code})`
      this.form.transferReceiver = `${item.receiver.branch_name} (${item.receiver.branch_code})`
      this.form.transferType = item.transfer_type
      this.form.transferNotes = item.transfer_notes
    },

    async getDocuments(id) {
      try {
        const response = await axios.get(
          `${process.env.VUE_APP_API_URL}${apiEndpoints.API_GET_DOCUMENTS}transfer/${id}`,
          { headers: this.authHeaders },
        )

        if (response.data.success) {
          this.documents = response.data.data
        }
      } catch (e) {
        console.error(e)
        this.showToast('Get Documents Failed', 'Could not load documents', 'danger')
      }
    },
    async getTransferDetails(id) {
      try {
        const response = await axios.get(
          `${process.env.VUE_APP_API_URL}${apiEndpoints.API_GET_TRANSFER_DETAILS}${id}/with_send`,
          { headers: this.authHeaders },
        )

        if (response.data.success) {
          const rawData = response.data.data

          if (this.isAssetTransfer) {
            // ASSET: Jangan digabung karena setiap aset itu unik
            this.items = rawData.map(elem => ({
              id: elem.transfer_detail_id,
              item: elem.item,
              qty: elem.transfer_detail_item_qty_requested,
              accepted: elem.transfer_detail_item_qty_requested,
              shelf: '', // Format string kosong (atau object null jika pakai vue-select)
              asset: elem.asset || null,
              original_details: [elem],
            }))
          } else {
            // STOK / NON-ASSET: Gabungkan berdasarkan item_id
            const grouped = new Map()

            rawData.forEach(elem => {
              const itemId = elem.item.item_id
              if (!itemId) return
              const qtyReq = parseInt(elem.transfer_detail_item_qty_requested || 0)

              if (grouped.has(itemId)) {
                // Jika sudah ada, tambahkan total qty-nya
                const existing = grouped.get(itemId)
                existing.qty += qtyReq
                existing.accepted += qtyReq
                existing.original_details.push(elem) // Simpan data aslinya untuk nanti dipecah
              } else {
                // Jika belum ada, buat baris baru
                grouped.set(itemId, {
                  id: elem.transfer_detail_id,
                  item: elem.item,
                  qty: qtyReq,
                  accepted: qtyReq,
                  shelf: null, // Siap menampung pilihan dropdown
                  asset: null,
                  original_details: [elem],
                })
              }
            })

            // Ubah Map kembali menjadi Array untuk ditampilkan di tabel
            this.items = Array.from(grouped.values())
          }

          this.showToast('Success', 'Fetching Data success', 'success')
        } else {
          throw new Error('API returned false success')
        }
      } catch (e) {
        console.error(e)
        this.showToast('Error', 'Fetching Data failed', 'danger')
      }
    },

    validateSubmission() {
      const invalidQty = this.items.some(o => !o.accepted || o.accepted === 0)
      if (invalidQty) {
        this.showToast('Validation Error', 'Please fill all accepted quantities', 'danger')
        return false
      }

      if (!this.isAssetTransfer) {
        // UBAH BAGIAN INI: Cek o.shelf.value
        const invalidShelf = this.items.some(o => !o.shelf || !o.shelf.value || o.shelf.value === '')
        if (invalidShelf) {
          this.showToast('Validation Error', 'Please select a shelf for all items', 'danger')
          return false
        }
      }

      return true
    },

    async submitConfirmTransfer() {
      if (this.isSubmitDisabled) return
      if (!this.validateSubmission()) return

      this.isSubmitDisabled = true

      // --- LOGIKA UN-MERGE (MEMECAH KEMBALI) ---
      const payloadItems = []

      this.items.forEach(mergedItem => {
        if (this.isAssetTransfer) {
          payloadItems.push({
            id: mergedItem.id,
            item: mergedItem.item,
            accepted: mergedItem.accepted,
            shelf: mergedItem.shelf,
            asset: mergedItem.asset,
          })
        } else {
          // Distribusikan total "accepted" ke masing-masing ID aslinya
          let remainingAccepted = parseInt(mergedItem.accepted || 0)

          mergedItem.original_details.forEach(orig => {
            const origQty = parseInt(orig.transfer_detail_item_qty_requested || 0)

            // Berapa yang dialokasikan ke ID ini? (Maksimal sesuai request aslinya)
            const take = Math.min(origQty, remainingAccepted)

            payloadItems.push({
              id: orig.transfer_detail_id,
              item: mergedItem.item,
              accepted: take,
              shelf: mergedItem.shelf,
              asset: mergedItem.asset,
            })

            remainingAccepted -= take
          })
        }
      })
      // ----------------------------------------

      // Kirim payloadItems yang sudah dipecah, bukan this.items
      const body = {
        transfer_items: JSON.stringify(payloadItems),
        time: moment(),
      }

      try {
        const url = `${process.env.VUE_APP_API_URL}${apiEndpoints.API_CONFIRM_TRANSFER_BY_WAREHOUSE_SENDER}/${this.transferId}`

        const response = await axios.post(url, body, { headers: this.authHeaders })

        if (response.data.success) {
          this.showToast('Success', 'Confirm Transfer Success', 'success')
          this.$router.replace({ name: 'apps-transfers-list' })
        } else {
          throw new Error(response.data.message || 'Unknown error')
        }
      } catch (error) {
        console.error(error)
        let errorMessage = 'Confirm Transfer Failed'
        if (error.response && error.response.data && error.response.data.message) {
          errorMessage = error.response.data.message
        } else if (error.request) {
           errorMessage = 'Network error. Please check your connection.'
        }
        this.showToast('Error', errorMessage, 'danger')
      } finally {
        this.isSubmitDisabled = false
      }
    },

    async downloadAttachment(document) {
      const payload = {
        ObjectName: `${document.document_number}${document.document_file_name}`,
        FileName: document.document_file_name,
      }

      try {
        const response = await axios.post(
          `${process.env.VUE_APP_API_URL}${apiEndpoints.API_DOWNLOAD_ASSET}`,
          payload,
          { headers: this.authHeaders },
        )

        if (response.data.Status === 1) {
          window.open(response.data.Payload, '_blank')
          this.showToast('Success', 'Download Attachment success', 'success')
        } else {
          this.showToast('Error', 'Download failed', 'danger')
        }
      } catch (e) {
        console.error(e)
        this.showToast('Error', 'Something went wrong', 'danger')
      }
    },

    previous() {
      this.$router.push({ name: 'apps-transfers-list' })
    },

    dateSimple(value) {
      if (!value) return null
      return moment.utc(value).tz('Asia/Jakarta').format('YYYY-MM-DD HH:mm:ss')
    },

    showToast(title, text, variant) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title,
          text,
          icon: variant === 'success' ? 'CheckIcon' : 'AlertTriangleIcon',
          variant,
        },
      })
    },

    buildTimelineStatus(item) {
      const getStatusObj = (title, userObj, time, isConfirmed, failMsg) => ({
        title,
        content: isConfirmed
          ? `Accepted by ${userObj?.user_fullname || 'Unknown'} at ${this.dateSimple(time)}`
          : failMsg,
        stepCssClass: isConfirmed ? 'has-step-green' : 'has-step-red',
      })

      const createdObj = {
        title: 'Created',
        content: `Transfer Has been Created By ${item.creator?.user_fullname} at ${this.dateSimple(item.transfer_created_time)}`,
        stepCssClass: 'has-step-green',
        boxCssClass: 'has-color-red',
      }

      return [
        createdObj,
        getStatusObj('Lab Manager Requester', item.lab_manager_receiver, item.transfer_confirmed_by_lab_manager_receiver_time, item.transfer_confirmed_by_lab_manager_receiver, 'Not Accepted By Lab Manager Requester'),
        getStatusObj('Regional Manager Requester', item.regional_manager, item.transfer_confirmed_by_regional_manager_sender_time, item.transfer_confirmed_by_regional_manager_sender, 'Not Accepted By Regional Manager'),
        getStatusObj('Division Head', item.division_head, item.transfer_confirmed_by_division_head_sender_time, item.transfer_confirmed_by_division_head_sender, 'Not Accepted By Division Head'),
        getStatusObj('FA Coal Manager', item.fa_coal_manager, item.transfer_confirmed_by_fa_coal_manager_sender_time, item.transfer_confirmed_by_fa_coal_manager_sender, 'Not Accepted By FA Coal Manager'),
        getStatusObj('Lab Manager Sender', item.lab_manager_sender, item.transfer_confirmed_by_lab_manager_sender_time, item.transfer_confirmed_by_lab_manager_sender, 'Not Accepted By Lab Manager Sender'),

        {
          title: 'Warehouse Sender',
          content: item.transfer_sent_by_sender ? `Sent By ${item.warehouse_sender?.user_fullname} at ${this.dateSimple(item.transfer_sent_by_sender_date)}` : 'Not Sent by Warehouse',
          stepCssClass: item.transfer_sent_by_sender ? 'has-step-green' : 'has-step-red',
        },
        {
          title: 'Warehouse Receiver',
          content: item.transfer_received_by_receiver ? `Received By ${item.warehouse_receiver?.user_fullname} at ${this.dateSimple(item.transfer_received_by_receiver_date)}` : 'Not Received by Warehouse',
          stepCssClass: item.transfer_received_by_receiver ? 'has-step-green' : 'has-step-red',
        },
      ]
    },
  },
}
</script>